// extracted by mini-css-extract-plugin
export default {"eventDescription":"vcrzUh","sideBySide":"cn7Jfr","descriptionSpacing":"WEHmf7"};